import { isFunction } from "@thi.ng/checks";
import { last, mapcat, push, reducer, repeat, scan, transduce, } from "@thi.ng/transducers";
export function tessellate(...args) {
    return transduce(scan(reducer(() => [args[0]], (acc, fn) => transduce(mapcat(fn), push(), acc))), last(), isFunction(args[1]) ? repeat(args[1], args[2] || 1) : args[1]);
}
